import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { Button } from 'blaze-ui/Button'
import { ArrowLeft, ArrowRight } from 'blaze-ui/icons'
import { IntegrationHelpButton } from 'components/IntegrationHelpButton/IntegrationHelpButton'
import cx from 'classnames'
import Styles from './BlazeExplainer.module.scss'

export interface BlazeExplainerProps {
  onNext: () => void
  onBack: () => void
}

export const BlazeExplainer = ({ onNext, onBack }: BlazeExplainerProps) => {
  return (
    <>
      <MultiStepStepLayout>
        <div className={Styles.container}>
          <h1 className={Styles.title}>How Blaze works</h1>

          <div className={Styles.stepsContainer}>
            <div className={Styles.stepSection}>
              <div className={Styles.stepHeader}>
                <div className={cx(Styles.numberBadge, Styles.green)}>1</div>
                <div className={Styles.stepTitle}>Blaze generates content for you</div>
              </div>
              <div className={Styles.stepContent}>
                <img
                  src="https://res.cloudinary.com/almanac/image/upload/v1759464118/virtual_marketer_onboarding/blaze_explainer_1.png"
                  alt="Blaze generates content for you"
                  className={Styles.stepImage}
                />
              </div>
            </div>

            <div className={Styles.stepSection}>
              <div className={Styles.stepHeader}>
                <div className={cx(Styles.numberBadge, Styles.orange)}>2</div>
                <div className={Styles.stepTitle}>You can make adjustments</div>
              </div>
              <div className={Styles.stepContent}>
                <img
                  src="https://res.cloudinary.com/almanac/image/upload/v1759464118/virtual_marketer_onboarding/blaze_explainer_2.png"
                  alt="You can make adjustments"
                  className={Styles.stepImage}
                />
              </div>
            </div>

            <div className={Styles.stepSection}>
              <div className={Styles.stepHeader}>
                <div className={cx(Styles.numberBadge, Styles.magenta)}>3</div>
                <div className={Styles.stepTitle}>Blaze posts and learns from it</div>
              </div>
              <div className={Styles.stepContent}>
                <img
                  src="https://res.cloudinary.com/almanac/image/upload/v1759464118/virtual_marketer_onboarding/blaze_explainer_3.png"
                  alt="Blaze posts and learns from it"
                  className={Styles.stepImage}
                />
              </div>
            </div>
          </div>
        </div>
      </MultiStepStepLayout>

      <div className={Styles.footer}>
        <Button size="xl" variant="tertiary" frontIcon={ArrowLeft} onPress={onBack} aria-label="Back">
          Back
        </Button>
        <div className={Styles.footerButtonGroup}>
          <IntegrationHelpButton
            size="sm"
            message="Hello! I'm on the Blaze Explainer page in Autopilot Onboarding. Can you help me understand how Blaze works?"
          />
          <Button size="xl" endIcon={ArrowRight} onPress={onNext} aria-label="Makes sense, let's do it">
            Makes sense, let&apos;s do it
          </Button>
        </div>
      </div>
    </>
  )
}
